module.exports = __webpack_public_path__ + "img/malha-fina.2ffd3914.png";